import CalenderIcon from "./calender-icon.svg";
import PriceTagIcon from "./price-range-filter-icon.svg";
import PriceTagIconWhite from "./PriceTagIconWhite.svg";
import PriceTagBlackIcon from "../images/tag-black-icon.png";
import CloseBlackIcon from "../images/close-x.png";
import ChatIcon from "./chat-icon.png";
import PromoIcon from "../images/png-icons/promo-icon-percentage.svg";
import UserDummyIcon from "../icons/user-dummy.png";
import LeftCirleArrow from "../icons/left-arrow-circle.png";
import RightCirleArrow from "../icons/right-arrow-circle.png";
import SearchIcon from "../icons/search.png";
import SearchCloseIcon from "../icons/serach-clear.png";
import HeightIcon from "../icons/height-icon.png";

import Instagram from "../icons/instagram-icon.png";
import LinkedIn from "../icons/linkedIn-icon.png";

import MaleIcon from "../icons/male-icon.png";
import FemaleIcon from "../icons/female-icon.png";

import UniversityIcon from "../icons/university-icon.png";
import WorkSpaceIcon from "../icons/workspace.png";
import AddressIcon from "../icons/address-icon.png";
import AttendanceIcon from "../icons/attendance-icon.png"
import SubscribeInactive from "../icons/subscribe-inactive.png";
import SubscribeActive from "../icons/subcribe-active.png";
import EventContactIcon from "../icons/contact-host.png";
import SubscriberListIcon from "../icons/subscribed-list-icon.png"

const Icons = {SubscriberListIcon,EventContactIcon,SubscribeInactive, SubscribeActive, AttendanceIcon,AddressIcon, MaleIcon, FemaleIcon, UniversityIcon, WorkSpaceIcon, Instagram,LinkedIn, HeightIcon, SearchIcon, SearchCloseIcon, RightCirleArrow, LeftCirleArrow, CalenderIcon, PriceTagIcon, PriceTagIconWhite, PriceTagBlackIcon, CloseBlackIcon, ChatIcon, PromoIcon,UserDummyIcon };

export default Icons;